<template>
    <!-- /**
 * 共通ウィンドウ
 */ -->
    <div class="container">
        <div class="col-12 py-3">
            <template
                v-if="
                    !(
                        display.mobile.value &
                        (title == '基礎知識編' || title == 'ストーリー編')
                    )
                "
            >
                <h3 class="page-title">
                    {{ `${contentsName} ${title}` }}
                </h3>
            </template>
            <slot />
        </div>
    </div>
</template>

<script>
import { useDisplay } from "vuetify/lib/composables/display";
export default {
    name: "window",
    props: {
        title: {
            type: String,
            default: "",
        },
    },
    setup() {
        const display = useDisplay();
        return { display };
    },
    data() {
        return {
            contentsList: [
                //base
                { value: "pswd", label: "パスワード設定" },
                { value: "mail", label: "メール" },
                { value: "web", label: "ウェブ利用" },
                { value: "information", label: "情報漏洩" },
                { value: "incident", label: "インシデント" },
            ],
        };
    },
    computed: {
        contentsName() {
            let title = this.contentsList.find(
                (item) => item.value == this.$route.params.contents
            );
            if (title) {
                return title.label;
            }
            return "";
        },
    },
};
</script>